'use client';

import { VStack } from '@terra/ui-styled-system';
import { ReadOnlyCodeEditor } from '../../components/ReadOnlyCodeEditor';
import { MetaDefault } from '../../../../components/typography';
import {
  formatHtmlSource,
  readBrowserPageSource,
} from '../utils/browser-tool-output';

type BrowserPageSourceProps = {
  output: string;
};

export function BrowserPageSource({ output }: BrowserPageSourceProps) {
  const { url, html } = readBrowserPageSource(output);

  if (!html) {
    return null;
  }

  return (
    <VStack alignItems="flex-start" gap={2} width="100%">
      {url ? <MetaDefault color="fg.muted">{url}</MetaDefault> : null}
      <ReadOnlyCodeEditor
        value={formatHtmlSource(html)}
        language="html"
        maxHeight="360px"
        minHeight="44px"
        showLineNumbers
        showCopyButton={false}
      />
    </VStack>
  );
}
